import { Trans } from '@lingui/macro';
import { Center, Stack } from '@mantine/core';
// import { SearchRouteCardLoading } from '../../components/search-route-card/search-route-card';
import Lottie from 'lottie-react';

import { UiCard } from '../../components/ui/ui-card/ui-card';
import trainLoader from './train-loader.json';

export const SeachRoutesLoading = () => {
  return (
    <>
      {/*  */}
      <Stack>
        <UiCard
          title={
            <Center>
              <Trans>Ищем доступные маршруты...</Trans>
            </Center>
          }
        >
          <Lottie animationData={trainLoader} />
        </UiCard>
      </Stack>
    </>
  );
};
